const storageKey = 'aguadecoco';

export type SkuInfoType = {
  name: string;
  image: string;
  categoriesIds: string[];
  categoriesNames: string[];
  url: string;
  variations: string;
  complementName: string;
  addToCartLink: string;
  price: string;
  customMeasureType?: string;
  customMeasureTypeClean?: string;
  customMeasureValue?: string;
  available: boolean;
};

export type GetSkuInfoByProductListOptions = {
  useFqFilterProducts?: boolean;
};

/**
 * Busca informações do produto na API de busca pra poder apresentar mais detalhes no conteúdo de favoritos
 */
const getSkuInfoByProductList = async (idList: string[]): Promise<Record<string, SkuInfoType>> => {
  const idsToSearch = idList.reduce((stack, sId) => {
    const info = window?.aguadecoco.helpers.storage.read(`${storageKey}-${sId}`);
    if (!info) {
      stack.push(sId as never);
    }
    return stack;
  }, []);

  const handleError = function (err) {
    console.error(err);
    return new Response(
      JSON.stringify({
        code: 400,
        message: 'Error',
      }),
    );
  };

  const getSalesChannel = () => {
    return ((document.cookie.match(/^(.*)sc=(?<sc>[^;]+)(.*)$/) || {}).groups || {}).sc || '1';
  };

  if (idsToSearch.length) {
    try {
      const response = await fetch(
        `/api/catalog_system/pub/products/search/?${idsToSearch
          .map((i) => `fq=skuId:${i}`)
          .join('&')}&sc=${getSalesChannel()}`,
      ).catch(handleError);

      if (response.ok) {
        console.log('response', response);
        await response.json().then(async (products) => {
          if (!Array.isArray(products)) {
            return [];
          }

          for (const prod of products) {
            for (const sku of prod.items) {
              if (!idsToSearch.includes(`${sku.itemId}` as never)) {
                continue;
              }

              const seller = (sku?.sellers || []).find((s) => s.sellerDefault);
              const price = seller?.commertialOffer?.Price || '';
              const available = seller?.commertialOffer?.AvailableQuantity > 0;
              const variations = sku?.variations
                ?.map((variation) => {
                  return sku?.[variation]?.[0];
                })
                .join(', ');

              const productsInfo = {
                url: prod.link.split(window.location.hostname).reverse()?.[0],
                variations,

                productName: prod.productName,

                complementName: sku.complementName,
                addToCartLink: '/checkout/' + (seller?.addToCartLink ?? '#').split('/checkout/')?.reverse()?.[0],
                price: window.aguadecoco.helpers.format.money(price),
                available,
                sku,
                imagensUrl: sku.images,
                sizeFormated: sku.Tamanho ? `TAMANHO: ${sku.Tamanho.join('')}` : '',
              };
              window.aguadecoco.helpers.storage.save(`${storageKey}-${sku.itemId}`, productsInfo, 5);
            }
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  const result = idList.reduce((stack, sId) => {
    const info = window.aguadecoco.helpers.storage.read(`${storageKey}-${sId}`);
    if (info) {
      Object.assign(stack, { [sId]: info });
    }
    return stack;
  }, {});

  return result;
};

window.aguadecoco = window.aguadecoco || {};
Object.assign(window.aguadecoco, {
  helpers: Object.assign(window.aguadecoco.helpers || {}, {
    getSkuInfoByProductList,
  }),
});

export default {};
